import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import FooterOne from "../common/footer/FooterOne";

import CtaLayoutOne from "../component/cta/CtaLayoutOne";
import BlogData from "../data/blog/BlogData.json";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";
import BlogSidebar from "../component/blog/BlogSidebar";
import BlogAuthor from "../component/blog/BlogAuthor";
import Comment from "../component/blog/Comment";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import SEO from "../common/SEO";
import { FaPlay, FaAngleRight, FaAngleLeft } from "react-icons/fa";
import FsLightbox from "fslightbox-react";
import Slider from "react-slick";
import BlogListOne from "../component/blog/BlogListOne";
import { media_url, useBlog } from "../hooks/useBlog";
import { useDispatch } from "react-redux";
import { setBlogItems } from "../store/store";
import HeaderTwo from "../common/header/HeaderTwo";
import HeaderOne from "../common/header/HeaderOne";
import { logPageView, logEvent, logTiming } from "../services/analytics";
import BlogAttachments from "../component/blog/BlogAttachments";

const allBlogData = BlogData;

const BlogDetails = () => {
  // query params id
  const query = new URLSearchParams(window.location.search);
  const params = useParams();
  const blogId = parseInt(params.id);
  const [viewState, setViewState] = useState({
    post: null,
    loading: true,
  });
  const { getPost } = useBlog();
  const dispatch = useDispatch();
  const [pageStartTime] = useState(Date.now());

  const getBlogData = allBlogData.filter((blog) => blog.id === blogId);
  const detailsBlog = getBlogData[0];

  const [toggler, setToggler] = useState(false);

  function SlickNextArrow(props) {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <FaAngleRight />
      </div>
    );
  }

  function SlickPrevArrow(props) {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <FaAngleLeft />
      </div>
    );
  }

  var slideSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,

    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SlickNextArrow />,
    prevArrow: <SlickPrevArrow />,
  };

  const loadPostFromId = async (id) => {
    setViewState({ ...viewState, loading: true });
    const post = await getPost(id);
    var postBody = post.body;
    // remove all spaces inside > <
    postBody = postBody.replaceAll(/>\s+</g, "><");
    // remove empty tags than match <anyIncludingSpacesAnd="'"></anyIncludingSpaces>
    postBody = postBody.replaceAll(/<([a-zA-Z0-9]+)(\s+[^>]*)?>\s*<\/\1>/g, "");
    setViewState({ post: { ...post, body: postBody }, loading: false });
    dispatch(
      setBlogItems({
        currentPost: {
          ...post,
          body: postBody,
        },
      })
    );
    
    // Registrar pageview en Google Analytics
    logPageView(window.location.pathname, post.title);
    // Registrar evento de lectura de blog
    logEvent('Blog', 'View', post.title, post.id);
  };

  useEffect(() => {
    if (query.get("id")) {
      const id = query.get("id");
      loadPostFromId(id);
    }
  }, []);

  // listen to query param changes
  useEffect(() => {
    if (query.get("id")) {
      const id = query.get("id");
      loadPostFromId(id);
    }
  }, [query.get("id")]);

  // Registrar tiempo de lectura cuando el usuario abandona la página
  useEffect(() => {
    return () => {
      if (viewState.post) {
        const timeSpent = Math.round((Date.now() - pageStartTime) / 1000);
        logTiming('Blog', 'Reading Time', timeSpent, viewState.post.title);
      }
    };
  }, [viewState.post, pageStartTime]);

  if (!viewState.post) {
    return <div>Loading...</div>;
  }
  return (
    <>
      <SEO
        title={viewState.post.title}
        description={viewState.post.excerpt}
        keyword={viewState.post.keywords}
        author={viewState.post.author}
        image={media_url(viewState.post.images?.[0]?.image_thumb || viewState.post.image)}
      />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderOne />
        <BreadCrumbOne title={viewState.post.title} page="Blog" />
       
        <div className="section-padding-equal">
          <div className="container">
            <div className="row row-40">
              <div className="col-lg-8">
                <div className="single-blog">
                  <div className="single-blog-content blog-grid">
                    <div className="post-thumbnail">
                      {Array.isArray(viewState.post.images) ? (
                        <Slider {...slideSettings} className="slick-arrow-nav">
                          {viewState.post.images.map((data, index) => (
                            <div className="slide-item" key={index}>
                              <div
                                className="slide-sitem"
                                key={index}
                                style={{
                                  // background: '#101010ff',
                                  backgroundSize: "cover",
                                  backgroundRepeat: "no-repeat",
                                  backgroundPosition: "center",
                                  backgroundImage: `url(${media_url(
                                    data.image
                                  )})`,
                                  height: "500px",
                                  width: "100%",
                                  borderRadius: "8px",
                                }}
                              ></div>
                            </div>
                          ))}
                        </Slider>
                      ) : (
                        <img src={media_url(viewState.post.image)} alt="Blog" />
                      )}

                      {viewState.post.format === "video" ? (
                        <>
                          <div className="popup-video">
                            <button
                              className="play-btn"
                              onClick={() => setToggler(!toggler)}
                            >
                              <FaPlay />
                            </button>
                          </div>
                          <FsLightbox
                            toggler={toggler}
                            sources={[
                              "https://www.youtube.com/watch?v=1iIZeIy7TqM",
                            ]}
                          />
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="author">
                      {/* <div className="author-thumb">
                                                <img src={`${process.env.PUBLIC_URL}/${detailsBlog.author_avatar}`} alt="Blog Author" />
                                            </div> */}
                      <div className="info">
                        {/* <h6 className="author-name">{detailsBlog.author_name}</h6> */}
                        <ul className="blog-meta list-unstyled">
                          <li>{viewState.post.created}</li>
                          <li>{viewState.post.updated}</li>
                        </ul>
                      </div>
                    </div>

                    <div
                      dangerouslySetInnerHTML={{ __html: viewState.post.body }}
                    ></div>

                    <div className="row">
                      {viewState.post.features_img?.map((img, i) => (
                        <div className="col-6" key={i}>
                          <div className="featured-img">
                            <img src={media_url(img)} alt="Blog" />
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Sección de archivos adjuntos */}
                    {viewState.post.files && viewState.post.files.length > 0 && (
                      <BlogAttachments files={viewState.post.files} />
                    )}
                  </div>
                </div>
                {/* <BlogAuthor data={detailsBlog} /> */}
                {/* <Comment /> */}
              </div>
              <div className="col-lg-4">
                <BlogSidebar />
              </div>
            </div>
          </div>
        </div>

        <div className="section section-padding-equal pt-0 related-blog-area">
          <div className="container">
            <div className="section-heading heading-left">
              <h3 className="title">Artículos Relacionados</h3>
            </div>
            <div className="row g-0">
              <BlogListOne colSize="col-xl-6" itemShow="2" />
            </div>
          </div>
        </div>
        <CtaLayoutOne />
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default BlogDetails;
